import { ServerResponse } from "http"
import { NextPageContext } from "next"
import Error from "next/error"
import Head from "next/head"

import Breadcrumb from "~/components/organisms/Breadcrumb"
import Footer from "~/components/organisms/Footer"
import Header from "~/components/organisms/Header"
import { NewGradJobPage } from "~/components/pages/NewGradJobDetailPage/_Rich"
import { NewGradJobDetail } from "~/entities/NewGradJob"
import { internalLink } from "~/services/helper"
import RootStore from "~/stores/RootStore"

interface Props {
  newGradJob: NewGradJobDetail
}

const NewGradJob = ({ newGradJob }: Props) => {
  if (!newGradJob) {
    return <Error statusCode={404} />
  }

  const crumbs = [
    {
      name: "新卒求人トップ",
      link: internalLink(`/new-grad-jobs`),
    },
    {
      name: `${newGradJob.major_occupation.name}の新卒求人一覧`,
      link: internalLink(`/new-grad-jobs?major_occupation=${newGradJob.major_occupation.id}`),
    },
    {
      name: newGradJob.title,
      link: internalLink(`/new-grad-jobs/${newGradJob.id}`),
    },
  ]

  return (
    <>
      <Head>
        <title>
          {newGradJob.title} - {newGradJob.company.name} | Infra新卒（インフラ新卒）
        </title>
      </Head>
      <div>
        <Header showTab logoType="NewGradJobs" />
        <NewGradJobPage newGradJob={newGradJob} />
        <Breadcrumb crumbs={crumbs} />
      </div>
      <Footer />
    </>
  )
}

interface Context extends NextPageContext {
  initialStoreData: RootStore
  res: ServerResponse
}

NewGradJob.getInitialProps = async (ctx: Context) => {
  const { newGradJobStore } = ctx.initialStoreData
  const newGradJobId = Number(ctx.query["new-grad-job-id"])

  if (isNaN(newGradJobId)) {
    ctx.res.statusCode = 404
    return { newGradJob: null }
  }

  const newGradJob = await newGradJobStore.fetchById(newGradJobId, ctx.query.limitedUrlToken)

  if (!newGradJob) {
    ctx.res.statusCode = 404
  }

  return { newGradJob }
}

export default NewGradJob
